import { Option } from 'crm-core';
import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import { FormContext } from '../FormContext';
import { handleValidation, ValidatorRule } from '../validation';

export type NAUSelectProps = {
  label: string;
  name?: string;
  description?: React.ReactNode;
  options: Option[];
  value?: string | number;
  defaultValue?: string | number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  validators?: ValidatorRule[];
  disabled?: boolean;
  placeholder?: string;
};

const NAUSelect: FC<NAUSelectProps> = ({
  label,
  name,
  description,
  options,
  value = '',
  defaultValue,
  onChange,
  validators,
  disabled = false,
}) => {
  const selectRef = useRef<HTMLSelectElement>(null);
  const { registerInput, setInputError, registerValidation } =
    useContext(FormContext);

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    registerInput(label, selectRef);
    if (validators) {
      registerValidation(label, () => {
        if (disabled) {
          return true;
        }
        return handleValidation(
          selectRef.current?.value || '',
          validators,
          setErrorMessage,
          setInputError,
          label,
        );
      });
    }
  }, []);

  return (
    <div>
      {!!label?.length && (
        <label htmlFor={label} className="form-label">
          {label}
        </label>
      )}

      {description && <div className="form-help">{description}</div>}

      <select
        id={label}
        name={name}
        disabled={disabled}
        className={`form-select ${errorMessage ? 'is-invalid' : ''}`}
        value={value || defaultValue}
        onChange={(e) => {
          onChange(e);
          handleValidation(
            e.target.value,
            validators,
            setErrorMessage,
            setInputError,
            label,
          );
        }}
        aria-placeholder='Select'
        ref={selectRef}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>

      {errorMessage && <div className="invalid-feedback">{errorMessage}</div>}
    </div>
  );
};

export default NAUSelect;
